var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 13.6731C20.9979 11.8484 20.2721 10.099 18.9818 8.80876C17.6915 7.5185 15.9421 6.79273 14.1174 6.79065H7.80805L9.20354 5.39498C9.46518 5.13099 9.6116 4.77411 9.61077 4.40243C9.60994 4.03076 9.46193 3.67454 9.19913 3.41171C8.93632 3.14888 8.5801 3.00085 8.20843 3C7.83675 2.99915 7.47986 3.14555 7.21585 3.40718L3.42093 7.2021C3.15734 7.4657 3.00926 7.82322 3.00926 8.196C3.00926 8.56878 3.15734 8.9263 3.42093 9.1899L7.21585 12.9848C7.47986 13.2464 7.83675 13.3928 8.20843 13.392C8.5801 13.3911 8.93632 13.2431 9.19913 12.9803C9.46193 12.7175 9.60994 12.3612 9.61077 11.9896C9.6116 11.6179 9.46518 11.261 9.20354 10.997L7.80805 9.60165H14.1174C15.1972 9.60165 16.2328 10.0306 16.9963 10.7942C17.7599 11.5577 18.1888 12.5933 18.1888 13.6731C18.1888 14.7529 17.7599 15.7885 16.9963 16.552C16.2328 17.3156 15.1972 17.7445 14.1174 17.7445H4.41474C3.41493 18.1529 4.04564 17.7788 3.87405 17.8489C3.70246 17.919 3.54642 18.0223 3.41493 18.1529C3.28344 18.2836 3.17908 18.4389 3.10787 18.6101C3.03666 18.7812 3 18.9647 3 19.1501C3 19.3354 3.03666 19.519 3.10787 19.6901C3.17908 19.8612 3.28344 20.0166 3.41493 20.1472C3.54642 20.2778 3.70246 20.3812 3.87405 20.4513C4.04564 20.5214 4.22939 20.5568 4.41474 20.5556H14.1174C15.9421 20.5535 17.6915 19.8277 18.9818 18.5375C20.2721 17.2472 20.9979 15.4978 21 13.6731Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.82bc292a10bcc3d004a6e13e6dfc1e3e.svg";
export { ForwardRef as ReactComponent };